import React, { useState } from "react";
import { MapPin, Phone, Clock, ArrowUpRight } from "lucide-react";
import { LOCATIONS } from "../data/menu";

export const Visit = () => {
  const [active, setActive] = useState(0);
  const loc = LOCATIONS[active];

  return (
    <section id="visit" className="relative py-20 sm:py-32 bg-[#FFFDFB]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <p className="font-script text-[#FF6392] text-3xl -rotate-2 inline-block">come say hi,</p>
          <h2 className="font-serif-display text-3xl sm:text-5xl lg:text-6xl text-[#2D2327] tracking-tight mt-2">
            Find us in the <span className="italic text-[#FF6392]">Valley.</span>
          </h2>

          <div className="mt-8 flex flex-wrap gap-2" data-testid="location-tabs">
            {LOCATIONS.map((l, i) => (
              <button
                key={l.city}
                onClick={() => setActive(i)}
                data-testid={`location-tab-${l.city.toLowerCase().replace(/\s+/g, "-")}`}
                className={`px-5 py-2.5 rounded-full font-semibold text-sm transition-colors border ${
                  active === i
                    ? "bg-[#2D2327] text-white border-[#2D2327]"
                    : "bg-white text-[#2D2327] border-[#FFB3C6]/50 hover:border-[#FF6392]"
                }`}
              >
                {l.city}
              </button>
            ))}
          </div>

          <div className="mt-8 space-y-5">
            <div className="flex gap-4">
              <div className="h-10 w-10 rounded-full bg-[#FFE3EB] grid place-items-center shrink-0">
                <MapPin className="h-5 w-5 text-[#FF6392]" />
              </div>
              <div>
                <div className="text-xs uppercase tracking-[0.22em] text-[#FF6392] font-semibold">Address</div>
                <div className="mt-1 font-serif-display text-xl sm:text-2xl text-[#2D2327] leading-tight">{loc.address}</div>
                <div className="text-[#4A3F44]">{loc.cityState}</div>
              </div>
            </div>

            <div className="flex gap-4">
              <div className="h-10 w-10 rounded-full bg-[#FFE3EB] grid place-items-center shrink-0">
                <Clock className="h-5 w-5 text-[#FF6392]" />
              </div>
              <div>
                <div className="text-xs uppercase tracking-[0.22em] text-[#FF6392] font-semibold">Hours</div>
                <div className="mt-1 font-serif-display text-xl sm:text-2xl text-[#2D2327] leading-tight">{loc.hours}</div>
                <div className="text-[#4A3F44]">Pickup & delivery available every day.</div>
              </div>
            </div>

            <div className="flex gap-4">
              <div className="h-10 w-10 rounded-full bg-[#FFE3EB] grid place-items-center shrink-0">
                <Phone className="h-5 w-5 text-[#FF6392]" />
              </div>
              <div>
                <div className="text-xs uppercase tracking-[0.22em] text-[#FF6392] font-semibold">Call us</div>
                <a href={`tel:${loc.phone.replace(/[^0-9+]/g, "")}`} className="mt-1 font-serif-display text-xl sm:text-2xl text-[#2D2327] hover:text-[#FF6392]">
                  {loc.phone}
                </a>
              </div>
            </div>
          </div>

          <div className="mt-10 flex flex-wrap gap-3">
            <a
              href={loc.mapsLink}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="visit-get-directions"
              className="inline-flex w-full sm:w-auto justify-center items-center gap-2 rounded-full bg-[#FF6392] text-white px-6 py-3 font-semibold hover:bg-[#E84A7A] transition-colors"
            >
              Get directions <ArrowUpRight className="h-4 w-4" />
            </a>
            <a
              href={`tel:${loc.phone.replace(/[^0-9+]/g, "")}`}
              data-testid="visit-call-us"
              className="inline-flex w-full sm:w-auto justify-center items-center gap-2 rounded-full border-2 border-[#2D2327] text-[#2D2327] px-6 py-3 font-semibold hover:bg-[#2D2327] hover:text-white transition-all"
            >
              <Phone className="h-4 w-4" /> Call us
            </a>
          </div>
        </div>

        <div className="lg:col-span-7">
          <div className="relative overflow-hidden rounded-3xl sm:rounded-[2.5rem] border border-[#FFB3C6]/50 shadow-[0_18px_50px_rgba(0,0,0,0.08)] aspect-[5/4] sm:aspect-[16/11] bg-white">
            <iframe
              key={loc.mapsEmbed}
              title={`Don Donuts ${loc.city}`}
              src={loc.mapsEmbed}
              className="absolute inset-0 h-full w-full"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              data-testid="visit-map-embed"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Visit;
